module.exports = __webpack_public_path__ + "static/img/3.951dbe61.jpg";